import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function NightIcon({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (
    <Icon
      data-icon={'NightIcon'}
      viewBox='0 0 16 16'
      width={size}
      height={size} {...props}>
      <path d='M10.22,9.34A5.33,5.33,0,0,1,6,6a5.06,5.06,0,0,1-.34-2.46.23.23,0,0,0-.35-.21,5.27,5.27,0,1,0,7.9,5.92.23.23,0,0,0-.3-.28A5.24,5.24,0,0,1,10.22,9.34Z' />
    </Icon>
  );
}

export default styled(NightIcon)``;